const INPUT_ERROR_CLASS = 'input-error';
const INPUT_GROUP_INVALID_CLASS = 'smsir-input-group--invalid';

/** Toggle invalid styles on the host input and its wrapping `smsir-input-group`. */
export function setFormControlInvalidClass(hostEl: HTMLElement, invalid: boolean): void {
  hostEl.classList.toggle(INPUT_ERROR_CLASS, invalid);

  const inputGroup = hostEl.closest('smsir-input-group');
  if (inputGroup) {
    inputGroup.classList.toggle(INPUT_GROUP_INVALID_CLASS, invalid);
  }
}

/** Inserts the error after the field wrapper so sibling helper `smsir-input-hint` rows stay visible. */
export function placeFormErrorElement(
  errorEl: HTMLElement | null | undefined,
  hostEl: HTMLElement | null | undefined,
  options?: {appendedInput?: boolean},
): void {
  if (!errorEl || !hostEl) {
    return;
  }

  let anchor: HTMLElement =
    (hostEl.closest('smsir-input-group') as HTMLElement | null) ?? hostEl;

  const rowParent = findHorizontalActionRow(anchor);
  if (rowParent) {
    const fieldsInRow = rowParent.querySelectorAll(
      'smsir-input-group, app-line-id-selector, textarea[smsirtextarea], textarea[smsirTextarea]',
    ).length;
    if (fieldsInRow <= 1) {
      anchor = rowParent;
    }
  }

  if (anchor.parentNode) {
    if (errorEl.parentNode !== anchor.parentNode || errorEl.previousSibling !== anchor) {
      anchor.parentNode.insertBefore(errorEl, anchor.nextSibling);
    }
  } else if (options?.appendedInput) {
    const parent = errorEl.parentElement?.parentElement;
    if (parent && errorEl.parentNode !== parent) {
      parent.appendChild(errorEl);
    }
  }

  // Final guard: never leave the message inside the pill.
  const stillInGroup = errorEl.closest('smsir-input-group') as HTMLElement | null;
  if (stillInGroup?.parentNode) {
    stillInGroup.parentNode.insertBefore(errorEl, stillInGroup.nextSibling);
  }
}

function findHorizontalActionRow(from: HTMLElement): HTMLElement | null {
  const parent = from.parentElement;
  if (!parent || !isHorizontalContainer(parent)) {
    return null;
  }

  // Place below the whole row so the error is never a flex/grid sibling of the field.
  return parent;
}

function isHorizontalContainer(el: HTMLElement): boolean {
  const style = getComputedStyle(el);

  if (style.display === 'flex' || style.display === 'inline-flex') {
    const direction = style.flexDirection || 'row';
    return direction === 'row' || direction === 'row-reverse';
  }

  if (style.display === 'grid') {
    const cols = style.gridTemplateColumns?.trim();
    if (!cols || cols === 'none') {
      return false;
    }
    return cols.split(/\s+/).length > 1;
  }

  return false;
}
